import React, { useState } from 'react';
import { format, utcToZonedTime } from 'date-fns-tz';
import DatePicker from 'react-datepicker';
import { useSearchFiltersContext } from '@context/searchFiltersContext';

import 'react-datepicker/dist/react-datepicker.css';

const getEasternDate = date => {
    if (!date) return null;
    const stringDate = format(date, 'yyyy-MM-dd');
    return utcToZonedTime(Date.parse(stringDate), 'America/New_York');
};

const EventFilterDateRange = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const { updateDateRangeFilter } = useSearchFiltersContext();

    const onSetStartDate = date => {
        // all event dates are in Eastern.
        // So get date without timezone, then convert it to eastern for config filter
        // but show local time.
        setStartDate(date);
        updateDateRangeFilter(getEasternDate(date), endDate);
    };

    const onSetEndDate = date => {
        // all event dates are in Eastern.
        // So get date without timezone, then convert it to eastern for config filter
        // but show local time.
        setEndDate(date);
        updateDateRangeFilter(startDate, getEasternDate(date));
    };

    return (
        <>
            <div className="pb-3 pt-2">
                <h6 className="form-control-label">From</h6>
                <DatePicker
                    className="form-control p-2"
                    selected={startDate}
                    onChange={onSetStartDate}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                />
            </div>
            <div className="pb-4">
                <h6 className="form-control-label">To</h6>
                <DatePicker
                    className="form-control p-2"
                    selected={endDate}
                    onChange={onSetEndDate}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                />
            </div>
        </>
    );
};

// EventFilterDateRange.propTypes = {
//     prop: PropTypes.
// };

export default EventFilterDateRange;
